import React, {forwardRef, useEffect, useRef, useState} from "react";
import {
    createCopyLink,
    createEmptyProject,
    formatDate,
    generateUUID2,
    getBase64ImageSize,
    getCtrlOrAlt,
    getFileNameExt,
    getImagePathWithTheme,
    getItem,
    getVideoScale,
    hasBeyondFreeLimit,
    isArray,
    isCardEmpty,
    isCardEmptyCard,
    isDarkMode,
    isPdf,
    isString,
    isStringNullOrEmpty,
    isVideo,
    MenuItem,
    removeHtmlTags
} from "@/utils";
import './PageJournal.css'
import moment, {updateLocale} from "moment";
import {t} from "i18next";
import {ConfigProvider, DatePicker, DatePickerProps, Dropdown, message, Popover, Tooltip} from "antd";
import Editor from "@/components/EditorV2";
import emitter, {
    DEFAULT_NOTE_HEIGHT,
    DEFAULT_NOTE_WIDTH,
    EVENT_LANGUAGE_CHANGED, EVENT_REFRESH_JOURNAL, EVENT_REFRESH_LIBRARY_LIST,
    EVENT_SHOW_DESKTOP_PRO_VIP,
    EVENT_SYNC_CARD_DATA_FROM_PAGECARD,
    EVENT_SYNC_CARD_DATA_FROM_RIGHT_SLIDER, EVENT_SYNC_JOURNAL_DATA_FROM_PAGEJOURNAL,
    EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER, FROM_ADD, FROM_DIALOG, FROM_HOME_LIBRARY,
    FROM_JOURNAL,
    FROM_LIBRARY, FROM_PAGE_CARD, FROM_RIGHT_SIDE,
    getNoteElementBackgroundColor,
    getNoteElementStrokeColor, HOME_LEFT_MENU_WIDTH,
    KEY_FILE_DIR,
    KEY_JOURNAL_SELECT_DATE, KEY_JOURNAL_SELECT_VIEW, LEFT_MENU_WIDTH,
    MAP_MONTH,
    MAP_MONTH_FULL,
    MAP_WEEK,
    MAP_WEEK_FULL,
    MENU_SEPARATOR, WIDTH_3, WIDTH_4, WIDTH_5
} from "@/Const";
import {
    deleteCard,
    getCardById, getCardByIds,
    getCardList,
    getJournalByFormatDate,
    getJournalByFormatDateExist,
    updateCard
} from "@model/card";
import dayjs from 'dayjs';
import {Calendar} from "antd/lib";
import {postMessage, recvMessage, unSubscribe} from "@/common/event";
import {getNoteDoc, updateNote, updateNoteDoc} from "@model/note";
import {ROUNDNESS} from "../../../@excalidraw/packages/excalidraw/constants";
import {ipcInvoke} from "@/common/ipc";
import DialogChooseProject from "@/views/Dialog/DialogChooseProject";
import {isZh} from "@/language";
import updateData from 'dayjs/plugin/updateLocale'

import enGB from 'antd/lib/calendar/locale/en_GB'
import HomeNavigator from "@/views/Home/HomeNavigator";
import {createBreadcrumb, getDrawPath, isMac} from "@/Utility";
import {
    IconAddToFavor,
    IconAddToProject,
    IconCopyLink,
    IconInfoMenu,
    IconManagerTags,
    IconMenuExportItem, IconRemoveFavor, IconSearch,
    IconVersionHistory
} from "@/Icon";
import {APP_WEB_WWW} from "@/electron_interactive";
import {useAtom} from "jotai";
import {atomSliderWidth} from "@/App";
import {KEYS} from "../../../@excalidraw/packages/excalidraw/keys";
import SideBarFold, {atomIsSideBarExpand} from "@/components/EditorV2/SideBarFold/SideBarFold";
import {resetRootPostionNormal, setRootPostionFixed} from "@/Utility0";
import {useLocation} from "react-use";
import CardItem from "@/views/Library/CardItem";
import {json} from "express";
import {onCardItemClick} from "@/views/Library/HandleLibraryItemUtils";

dayjs.extend(updateData);

let mIsChangeMonth=false;
let mSelectMonth = new Date().getMonth();
let mProjectInfo:any;

const PageJournal = forwardRef((props:{from?:any,onUpdate?:any,journalData?:any}, ref)=> {

    const [arrayCalendar, setArrayCalendar] = useState([]);
    const [isOpenDatePicker,setIsOpenDatePicker] = useState(false);
    const [selectDate,setSelectDate] = useState(new Date());
    const [cardJournal,setCardJournal] = useState<any>(null);
    const [tipsInfo,setTipsInfo] = useState('');
    const [isLeftPartOpened,setIsLeftPartOpened] = useState(false);

    const [,updateState] = useState();
    const forceUpdate = React.useCallback(()=>updateState({}),[]);

    const [rightSliderWidth,setRightSliderWidth] = useAtom(atomSliderWidth);
    // const [isSidebarExpand] = useAtom(atomIsSideBarExpand);

    const editorRef = useRef();
    const dialogChooseProjectRef = useRef();
    const calendarRef = useRef(null);

    const [editor,setEditor] = useState(null);
    const [headerTreeWidth,setHeaderTreeWidth] = useState(0);
    const [sideBarStatus, setSideBarStatus] = useState<any>(0);
    const [selectView,setSelectView] = useState<'daily' | 'monthly' | any>(localStorage.getItem(KEY_JOURNAL_SELECT_VIEW) || 'daily');
    const [arrayJournalMonthly,setArrayJournalMonthly] = useState([]);
    const [gridColumns,setGridColumns] = useState('repeat(4,auto)');
    const [cardItemSize,setCardItemSize] = useState({width:0,height:0});

    let szOldId = useRef<string>('')
    const mSelectDate = useRef<any>(null);
    const mIsDateClicked = useRef(true);
    const sideBarFoldRef = useRef(null);
    const divScrollContainer = useRef(null);
    const divJournalMonthlyContainerRef = useRef(null);
    const [currentMonthlyDate,setCurrentMonthlyDate] = useState<any>(new Date());
    //这个是给日历视图用的。
    const mArrayJournals=useRef([]);
    //这个给弹窗的日历视图用
    const mArrayPopupCalendarJournals = useRef([]);

    const params = useLocation();

    //分享菜单
    const MENU_MORE = ()=>{
        return [
            getItem(t("ExportPDF"), 'exportPdf', <IconMenuExportItem/>, undefined, undefined, async () => {
                editorRef.current?.onExportPdf();
            }),
            getItem(t("ExportMarkdown"), 'exportMarkdown', <IconMenuExportItem/>, undefined, undefined, async () => {
                editorRef.current?.onExportMarkdown();
            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),
            // getItem(cardJournal?.isFavirated === 1?t('Cancel favor'):t("Add to Favorites"), 'favor', cardJournal?.isFavirated === 1?<IconRemoveFavor/>:<IconAddToFavor/>, undefined, undefined, async () => {
            //     const ccccccc = await editorRef.current?.save?.();
            //     if (isCardEmpty(ccccccc.doc)){
            //         message.error(t('InputContentBefore'));
            //         return;
            //     }
            //     await updateCard({
            //         ...cardJournal,
            //         ...ccccccc,
            //         isFavirated: (cardJournal.isFavirated == 1) ? 0 : 1
            //     }).then(res=>{
            //         postMessage(EVENT_FAVIRIATE_CHANGE);
            //     });
            //     const card = await getCardById(cardJournal.id, true);
            //     setCardJournal(card);
            // }),
            getItem(t("Search"), 'search', <IconSearch/>, undefined, undefined, async () => {
                window.GSearchOpen?.()
            }),
            getItem(t("Show info"), 'showInfo', <IconInfoMenu/>, undefined, undefined, async () => {
                const saveData:any = editorRef.current?.getSaveData();
                cardJournal.doc = saveData.doc;
                cardJournal.name = saveData.name;
                cardJournal.type = 'journal';
                if (!cardJournal.createTime){
                    cardJournal.createTime = Date.now();
                    cardJournal.updateTime = Date.now();
                }
                window.showInfo('library',cardJournal)
            }),
            getItem(<div>{t("Version history")}<label className={'beta'}>{'Beta'}</label></div>, 'versionHistory', <IconVersionHistory/>, undefined, undefined, () => {
                //历史记录
                window.showDialogCardHistory(cardJournal?.id,(newProject:any)=>{
                    setCardJournal(newProject);
                });
            }),
            getItem(MENU_SEPARATOR, generateUUID2(), null, undefined, 'divider', () => {

            }),

            getItem(t("Manage tags"), 'manageTags', <IconManagerTags/>, undefined, undefined, async () => {
                //如果是新建的card,操作标签前先保存这个card
                let card:any = await getCardById(cardJournal.id,false);
                let ddddddatatataat = cardJournal;

                if (!card){
                    // logger('save as a new card....');
                    const ccccccc =  await editorRef.current?.save?.();
                    await updateCard({
                        ...ccccccc,
                        type:'journal'
                    },true,true,'fromManageTag');
                    card = await getCardById(cardJournal.id,true);

                    ddddddatatataat = card;
                    global.g_currentNoteData = card;
                }
                window.showManageTags([ddddddatatataat],()=>{

                });
            }),
            getItem(t("Copy link"), 'copyLink', <IconCopyLink/>, undefined, undefined, () => {
                createCopyLink('library',cardJournal.id,'journal',null);
            }),
            getItem(t("Add to whiteboard"), 'addToWhiteboard', <IconAddToProject/>, undefined, undefined, async () => {
                const ccccccc =  await editorRef.current?.save?.();
                await updateCard({
                    ...ccccccc,
                    type:'journal'
                },true,true,'fromManageTag');
                getCardById(cardJournal.id)?.then(res=>{
                    window.showDialogChooseProject([res]);
                })
            }),

            // getItem(t("Delete"), 'delete', null, undefined, undefined, () => {
            //     handleMenuClick({key:ENoteAction.delete})
            // }),
        ]
    };

    /**
     * 按键
     * @param event
     */
    function onKeyDown(event:any){
        // debugLog('keydown',event);

        let szKey = event.key.toLowerCase();
        if ((event.metaKey || event.ctrlKey)){
            if (szKey == KEYS.F){
                window.GSearchOpen?.()
            }else if (szKey == KEYS.S){
                sideBarFoldRef.current?.onToggleBar();
            }
        }else if (event.key == KEYS.ESCAPE){
            window.closePopupCardList();
        }
    }

    /**
     * 窗口大小调整
     * @param event
     */
    function onWindowResize(){
        if (divJournalMonthlyContainerRef.current){
            onSliderEvent(divJournalMonthlyContainerRef.current.clientWidth - 20*2);//左右边距
        }else{
            onSliderEvent(document.body.clientWidth - HOME_LEFT_MENU_WIDTH - 20*2);//左右边距
        }
    }

    /**
     * 刷新tag
     * @param newData
     */
    window.refreshTag = (newData:any)=>{
        //如果从外面配置了tag ，这里要想办法去刷新。
        if (newData.id == cardJournal.id){
            var ttttt = {...cardJournal};
            ttttt.tags = newData.tags;
            setCardJournal(ttttt);
        }
    }

    /**
     * 装card的滚动
     */
    window.getCardScrollContainer = ()=>{
        return divScrollContainer.current;
    }


    useEffect(()=>{
        //接收update消息
        recvMessage(EVENT_SYNC_CARD_DATA_FROM_PAGECARD,(msg,data)=>{
            const card = data.data.data;
            if (cardJournal?.id && cardJournal?.id == card.id){
                const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
                if (isStringNullOrEmpty(removeHtmlTags(card.doc)) && isEmptyTitle && card.doc.indexOf('<img') == -1){
                    return;
                }

                card.type = card.type || 'journal';
                setCardJournal(card);
                // updateCard(card,true,true,'fromCanvasListIndex-EVENT_UPDATE_NOTE').then((res)=>{
                //
                // });
            }
        })

        recvMessage(EVENT_REFRESH_JOURNAL,(msg,data)=>{
            getCardById(data.data.id).then(res=>{
                setCardJournal(res);
            })
        })

        /**
         * 刷新月视图
         */
        recvMessage(EVENT_REFRESH_LIBRARY_LIST,(msg,data)=>{
            refreshJournalMonthly();
        })

        //正常的pagejournal，监听这个消息
        if (props.from != FROM_LIBRARY){
            recvMessage(EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER,(msg,data)=>{
                const card = data.data.data;
                if (cardJournal?.id && cardJournal?.id == card.id){
                    const isEmptyTitle = isStringNullOrEmpty(card.name) || card.name.toLowerCase() == t("Untitled").toLowerCase();
                    if (isStringNullOrEmpty(removeHtmlTags(card.doc)) && isEmptyTitle && card.doc.indexOf('<img') == -1){
                        return;
                    }

                    card.type = card.type || 'journal';
                    setCardJournal(card);
                    // updateCard(card,true,true,'fromCanvasListIndex-EVENT_UPDATE_NOTE').then((res)=>{
                    //
                    // });
                }
            })
        }

        document.body.addEventListener('keydown',onKeyDown);
        window.addEventListener('resize',onWindowResize);

        return ()=>{
            unSubscribe(EVENT_SYNC_CARD_DATA_FROM_PAGECARD);
            unSubscribe(EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER);
            unSubscribe(EVENT_REFRESH_JOURNAL);
            unSubscribe(EVENT_REFRESH_LIBRARY_LIST);

            document.body.removeEventListener('keydown',onKeyDown);
            window.removeEventListener('resize',onWindowResize);
        }
    })

    useEffect(() => {
        setRootPostionFixed();

        // recvMessage(EVENT_FORCE_UPDATE,(msg,data)=>{
        //     forceUpdate();
        // })

        updateLanguage();

        refreshJournals();

        setCurrentPopupJournal(currentMonthlyDate);

        //侧边栏的只显示日记视图
        if (props.from == FROM_LIBRARY){
            setSelectView('daily');
        }else{
            window.refreshMonthly = ()=>{
                refreshJournalMonthly();
            }
        }

        if (selectView == 'monthly'){

        }
        onWindowResize(null);

        window.refreshList['updateTheme_pageJournal'] = forceUpdate;

        return ()=>{
            // unSubscribe(EVENT_FORCE_UPDATE);
            resetRootPostionNormal();
            delete window.refreshTag;
            delete window.getCardScrollContainer;
            if (props.from != FROM_LIBRARY) {
                delete window.refreshMonthly;
            }
            delete window.refreshList['updateTheme_pageJournal'];
            window.closeAddNoteWindow();
            ipcInvoke('update-backup-time');
        }
    }, []);

    useEffect(()=>{
        if (params.state?.usr?.id){
            if (cardJournal && editor){
                const data = editorRef.current?.getSaveData();
                const newData = {...cardJournal,doc:data.doc}
                onSaveData(newData);
            }
            getCardById(params.state?.usr?.id, true).then(res=>{
                resetWeek(new Date(res.journalTime))
            });
        }else{
            if (!props.journalData){
                const lDate = localStorage.getItem(KEY_JOURNAL_SELECT_DATE);
                if (lDate){
                    resetWeek(new Date(parseInt(lDate)),true);
                }else{
                    resetWeek(new Date(),true);
                }
            }
        }
    },[params])

    useEffect(()=>{
        if (props.journalData){
            setSelectDate(new Date(props.journalData.journalTime));
            setCardJournal(props.journalData);
        }
    },[props.journalData])

    useEffect(()=>{
        if (selectDate){
            localStorage.setItem(KEY_JOURNAL_SELECT_DATE,selectDate.getTime()+'');
            mSelectDate.current = selectDate;
            setCurrentMonthlyDate(new Date(selectDate));
        }

        recvMessage(EVENT_LANGUAGE_CHANGED,(msg,data)=>{
            updateLanguage();
            resetWeek(selectDate,true);
        })

        return ()=>{
            unSubscribe(EVENT_LANGUAGE_CHANGED);
        }

    },[selectDate])

    useEffect(() => {
        onWindowResize();
    }, [rightSliderWidth]);

    useEffect(()=>{
        if (selectView == 'monthly'){
            setTimeout(()=>{
                const startDate = dayjs(new Date());
                const szMonthDate = startDate.format('YYYYMMDD');
                const id = 'j-'+szMonthDate;
                const cardItemView = document.getElementById('card-item-id-'+id);
                cardItemView?.scrollIntoView({ behavior: 'smooth', block: 'center',inline: 'nearest' });
            },200)
        }
    },[selectView])

    useEffect(() => {
        if (cardJournal && editor){
            editor.cardId = cardJournal.id
        }
    }, [cardJournal]);

    /**
     * 所有日记
     */
    const refreshJournals = ()=>{
        // getCardList(-1,0,'journal','','').then(res=>{
        //     mArrayJournals = res;
        //     //初始化的时候有这个...
        //     if (selectView == 'monthly'){
        //         filterJournalMonthly(res);
        //     }
        // })
        getCurrentMonthly();
    }

    /**
     * 刷新月视图
     */
    const refreshJournalMonthly = ()=>{
        // getCardList(-1,0,'journal','','').then(res=>{
        //     mArrayJournals = res;
        //     onWindowResize();
        //     filterJournalMonthly(res);
        // })

        getCurrentMonthly();
    }

    /**
     * 设置当月的日历情况
     */
    const setCurrentJournal = async ()=>{
        const arrayIds = [];
        //本月最大的天数--没有的补上。
        const date = dayjs(currentMonthlyDate);
        const nMaxDate = date.daysInMonth();
        const nYear = date.year();
        const nMonth = date.month();
        const startDate = dayjs(new Date(nYear,nMonth,1));
        for (let i=0;i<nMaxDate;i++){
            const dtMonth = startDate.add(i,'day');
            const szMonthDate = dtMonth.format('YYYYMMDD');
            arrayIds.push('j-'+szMonthDate);
        }
        const arrayJournals = await getCardByIds(arrayIds);
        mArrayJournals.current = arrayJournals;
    }

    const getCurrentMonthly = async ()=>{
        await setCurrentJournal();

        const date = dayjs(currentMonthlyDate);
        const nMaxDate = date.daysInMonth();
        const nYear = date.year();
        const nMonth = date.month();
        const startDate = dayjs(new Date(nYear,nMonth,1));

        const arrayMonthly:any = [];
        for (let i=0;i<mArrayJournals.current.length;i++){
            const journal = mArrayJournals.current[i];
            const dtMonth = startDate.add(i,'day');
            const szMonthDate = dtMonth.format('YYYYMMDD');
            if (!journal || journal?.isDeleted == 1){
                //这一天没有。。。
                const name = t(MAP_MONTH[`${dtMonth.month()+1}`]) + formatDate(dtMonth.toDate(), ' dd, yyyy');
                const forkJournal = {
                    id:'j-'+szMonthDate,
                    formatDate:szMonthDate,
                    type:'journal',
                    journalTime:dtMonth.toDate().getTime(),
                    name:name,
                    isEmpty:true
                }
                arrayMonthly.push(forkJournal);
            }else{
                arrayMonthly.push(journal);
            }
        }

        arrayMonthly.sort((a,b)=>{
            return a.journalTime - b.journalTime;
        })

        setArrayJournalMonthly(arrayMonthly);
    }


    const filterJournalMonthly = (res)=>{
        const szLocalMonth = formatDate(currentMonthlyDate,'yyyyMM');
        const arrayMonthly = res.filter(p=>p.formatDate?.includes(szLocalMonth));

        //本月最大的天数--没有的补上。
        const date = dayjs(currentMonthlyDate);
        const nMaxDate = date.daysInMonth();
        const nYear = date.year();
        const nMonth = date.month();
        const startDate = dayjs(new Date(nYear,nMonth,1));
        for (let i=0;i<nMaxDate;i++){
            const dtMonth = startDate.add(i,'day');
            const szMonthDate = dtMonth.format('YYYYMMDD');
            if (!arrayMonthly.some(p=>p.formatDate == szMonthDate)){
                //这一天没有。。。
                const name = t(MAP_MONTH[`${dtMonth.month()+1}`]) + formatDate(dtMonth.toDate(), ' dd, yyyy');
                const forkJournal = {
                    id:'j-'+szMonthDate,
                    formatDate:szMonthDate,
                    type:'journal',
                    journalTime:dtMonth.toDate().getTime(),
                    name:name,
                    isEmpty:true
                }
                arrayMonthly.push(forkJournal);
            }
        }

        arrayMonthly.sort((a,b)=>{
            return a.journalTime - b.journalTime;
        })

        setArrayJournalMonthly(arrayMonthly);
    }

    /**
     * 语言配置。。。。！IMP
     */
    const updateLanguage = ()=>{
        dayjs.updateLocale('en-gb',{
            weekdays: [
                "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
            ],
            weekdaysShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
            weekdaysMin: [t("Sun"), t("Mon"), t("Tue"), t("Wed"), t("Thu"), t("Fri"), t("Sat")],
            weekStart:1
        })

        //头部周一为开始，默认0
        moment.updateLocale('en', {
            week:{dow:1}
        });
    }

    /**
     * 选中日视图
     */
    const setViewToDaily = ()=>{
        //选中daily
        setSelectView('daily');
        localStorage.setItem(KEY_JOURNAL_SELECT_VIEW,'daily');
    }

    /**
     * 重置到今天
     */
    const resetWeek = async (today:any,isInit = false)=>{
        const startDate = moment(today).startOf('week');
        const endDate = moment(today).endOf("week");
        const arrayDates: any = [];
        let currentDate = startDate;
        mSelectMonth =  moment(today).month();
        while (currentDate <= endDate) {
            arrayDates.push({
                week: currentDate.weekday(),
                day: currentDate.date(),
                date: currentDate,
                isSelect: currentDate.isSame(today, 'day'),
                hasJournal:await getJournalByFormatDateExist(currentDate.toDate())
            });
            currentDate = moment(currentDate).add(1, 'day')
        }
        setArrayCalendar(arrayDates);
        setCurrentSelectDate(arrayDates);

        if (!isInit){
            setViewToDaily();
        }
    }

    /**
     * 上一周
     */
    const preWeek = async ()=> {
        const today = moment();
        const firstToday = arrayCalendar[0].date;
        const arrayDates: any = [];
        for (let i = 1; i <= 7; i++) {
            let currentDate = moment(firstToday).add(0 - i, 'day');
            arrayDates.push({
                week: currentDate.weekday(),
                day: currentDate.date(),
                date: currentDate,
                isSelect: currentDate.isSame(today, 'day'),
                hasJournal:await getJournalByFormatDateExist(currentDate.toDate())
            });
        }
        arrayDates.reverse();
        setArrayCalendar(arrayDates);
        setCurrentSelectDate(arrayDates);
    }

    /**
     * 下一周
     */
    const nextWeek = async ()=>{
        const today = moment();
        const firstToday = arrayCalendar[arrayCalendar.length-1].date;
        const arrayDates: any = [];
        for (let i = 1; i <= 7; i++) {
            let currentDate = moment(firstToday).add(i, 'day');
            arrayDates.push({
                week: currentDate.weekday(),
                day: currentDate.date(),
                date: currentDate,
                isSelect: currentDate.isSame(today, 'day'),
                hasJournal:await getJournalByFormatDateExist(currentDate.toDate())
            });
        }
        setArrayCalendar(arrayDates);
        setCurrentSelectDate(arrayDates);
    }

    /**
     * 当前选中的日期
     * @param arrayDates
     */
    const setCurrentSelectDate = async (arrayDates:any)=>{
        for (let i=0;i<arrayDates.length;i++){
            const item = arrayDates[i];
            if (item.isSelect){
                setSelectDate(item.date.toDate())
                var card = await getJournalByFormatDate(item.date.toDate()) || {type:'journal',journalTime:item.date.toDate(), name:(t(MAP_MONTH[`${item.date.toDate().getMonth()+1}`]) + formatDate(item.date.toDate(), ' dd, yyyy'))};

                if (card && card.journalTime){
                    card.name = t(MAP_MONTH[`${new Date(card.journalTime).getMonth()+1}`]) + formatDate(card.journalTime, ' dd, yyyy');
                }
                card.formatDate = formatDate(card.journalTime, 'yyyyMMdd');
                if (!card.id){
                    card.id = 'j-'+card.formatDate;
                }
                setCardJournal(card);
            }
        }
    }

    /**
     * 选中日期
     * @param date
     */
    const onSelectedDataChange = async (date:Date)=>{
        setSelectDate(date)
        var card = await getJournalByFormatDate(date) || {type:'journal',journalTime:date, name:(t(MAP_MONTH[`${date.getMonth()+1}`]) + formatDate(date, ' dd, yyyy'))};

        if (card && card.journalTime){
            card.name = t(MAP_MONTH[`${new Date(card.journalTime).getMonth()+1}`]) + formatDate(card.journalTime, ' dd, yyyy');
        }
        setCardJournal(card);
    }

    const getMonthDesc = (value:any)=>{
        const selectMonth = value.month() + 1
        if (isZh()){
            return formatDate(value,'yyyy年MM月')
        }
        return t(MAP_MONTH_FULL[`${selectMonth}`]) + '　' + value.year();
    }

    /**
     * 弹窗的切换日历情况
     */
    const setCurrentPopupJournal = async (monthlyDate)=>{
        const arrayIds = [];
        //本月最大的天数--没有的补上。
        const date = dayjs(monthlyDate);
        const nMaxDate = date.daysInMonth();
        const nYear = date.year();
        const nMonth = date.month();
        const startDate = dayjs(new Date(nYear,nMonth,1));
        for (let i=0;i<nMaxDate;i++){
            const dtMonth = startDate.add(i,'day');
            const szMonthDate = dtMonth.format('YYYYMMDD');
            arrayIds.push('j-'+szMonthDate);
        }
        const arrayJournals = await getCardByIds(arrayIds);
        mArrayPopupCalendarJournals.current = arrayJournals;
    }

    /**
     * 头部
     */
    const calendarHeaderRender = ({value, type, onChange, onTypeChange})=>{

        return <div className={'flex-row-vertical-center'} style={{padding: '6px 10px 12px 3px'}}>
            <span className={'font-family-semi-bold'}
                  style={{color: 'var(--primary-color)'}}>{getMonthDesc(value)}</span>
            <div style={{flexGrow:'1'}}></div>
            <img className={'img-18 cursor-pointer'} src={getImagePathWithTheme('calendar_month_left')}
                 onClick={() => {
                     mIsChangeMonth = true;
                     mIsDateClicked.current = false;
                     const newValue = value.clone().month(value.month() - 1);
                     setSelectDate(newValue.toDate());
                     onChange(newValue);
                 }}/>
            <img className={'img-18 ml-22 cursor-pointer'} src={getImagePathWithTheme('calendar_month_right')}
                 onClick={() => {
                     mIsDateClicked.current = false;
                     mIsChangeMonth = true;
                     const newValue = value.clone().month(value.month() + 1)
                     setSelectDate(newValue.toDate());
                     onChange(newValue)
                 }}/>
        </div>
    }

    /**
     * 左侧栏的新头
     * @param value
     * @param type
     * @param onChange
     * @param onTypeChange
     */
    const calendarHeaderRenderNew = ({value, type, onChange, onTypeChange})=>{
        return <div className={'flex-row-vertical-center'} style={{padding: '0px 16px 6px 12px',borderBottom:'1px solid var(--line-color)',marginBottom:'6px',marginLeft:'-16px',marginRight:'-16px'}}>
            <img className={'img-32 cursor-pointer'} src={getImagePathWithTheme('journal_calendar_pre')}
                 onClick={() => {
                     mIsChangeMonth = true;
                     mIsDateClicked.current = false;
                     const newValue = value.clone().month(value.month() - 1);
                     setSelectDate(newValue.toDate());
                     onChange(newValue);
                 }}/>
            <span className={'font-family-semi-bold'}
                  style={{color: 'var(--text-color)',fontSize:'14px'}}>{getMonthDesc(value)}</span>
            <img className={'img-32  cursor-pointer'} src={getImagePathWithTheme('journal_calendar_next')}
                 onClick={() => {
                     mIsDateClicked.current = false;
                     mIsChangeMonth = true;
                     const newValue = value.clone().month(value.month() + 1);
                     setSelectDate(newValue.toDate());
                     onChange(newValue)
                 }}/>

            {
                <span className={'flex-center cursor-pointer default-font-family'} style={{
                    border: '1px solid var(--color-dfdfdf)',
                    minWidth: '64px',
                    marginLeft:'auto',
                    height: '30px',
                    fontSize:'12px',
                    color:'var(--text-color)',
                    visibility: formatDate(selectDate) == formatDate(Date.now()) ? 'hidden' : 'visible',
                    borderRadius: '8px'
                }} onClick={() => {
                    mIsDateClicked.current = true;
                    resetWeek(new Date());
                }}>{t("Today")}</span>
            }
        </div>
    }

    const calendarCellRender = (current, info) => {
        if (info.type === 'date') {
            const szCurrentFormat = formatDate(current.$d, 'yyyyMMdd');
            const szCurrentDate = formatDate(new Date(), 'yyyyMMdd');
            const isCurDay = szCurrentDate == szCurrentFormat;
            let isSelectedDate = (mIsDateClicked.current ||  formatDate(cardJournal?.journalTime,'yyyyMMdd') == szCurrentFormat) && formatDate(selectDate,'yyyyMMdd') == szCurrentFormat;
            const isSelectedMonth = current.month() == mSelectMonth;//selectDate.getMonth() == current.$M;

            let hasJournal = mArrayPopupCalendarJournals.current.some(p => p?.formatDate == szCurrentFormat);
            if (cardJournal?.formatDate == szCurrentFormat){
                if (!isCardEmpty(cardJournal?.doc)){
                    hasJournal = true;
                }
            }
            if (selectView == 'monthly'){
                isSelectedDate = false;
            }

            const getTextColor = ()=>{
                if (isSelectedDate && selectView == 'daily'){
                    return 'white';
                }

                if (!isSelectedMonth){
                    return 'var(--color-7d7d7d)';
                }
                if (isCurDay && selectView == 'daily'){
                    return 'var(--primary-color)';
                }

                return 'var(--text-color)';
            }

            return (
                <div className={'flex-center'}>
                    <div className="ant-picker-cell-inner1"
                         style={{
                             display:'flex',flexDirection:'column',
                             justifyContent:'center',
                             alignItems:'center',
                             width:'28px',height:'28px',
                             border: "none",
                             borderRadius: '20px',
                             textAlign:'center',
                             background:(isSelectedDate && selectView == 'daily')?'var(--primary-color)':'transparent'
                         }}>
                        {/*{current.date()}*/}
                        <span
                            style={{color: getTextColor(),lineHeight:'28px',marginTop:'-3px'}}>{current.date()}</span>
                        <span style={{
                            marginTop: '-6px',
                            width: '4px',
                            height: '4px',
                            borderRadius: '2px',
                            background: (hasJournal && isSelectedDate )?'white':'var(--primary-color)',
                            display: hasJournal ? 'block' : 'none',
                        }}></span>
                    </div>
                </div>

            );
        }
        return info.originNode;
    }

    /**
     * 更新card并刷新.
     * @param data
     */
    const updateAndRefreshSom = (data: any) => {
        updateCard(data).then(res => {
            refreshJournals();
            //右侧栏，刷新列表
            if (props.from == FROM_LIBRARY){
                if (window.refreshMonthly){
                    window.refreshMonthly();
                }
            }
            // postMessage(EVENT_REFRESH_LIBRARY_LIST);这个没用，因为可能已经unsub了
            window.globalRefreshList('refreshLibraryList_');
        })
        let arrayNew = [...arrayCalendar];
        for (let i = 0; i < arrayNew.length; i++) {
            if (formatDate(arrayNew[i].date.toDate(), 'yyyyMMdd') == data.formatDate) {
                arrayNew[i].hasJournal = true;
            }
        }
        setArrayCalendar(arrayNew);
    }

    const onSaveData = (data:any)=>{
        //保存....
        data.type = 'journal';
        data.formatDate = formatDate(selectDate, 'yyyyMMdd');
        data.journalTime = selectDate.getTime();
        if (data.id) {
            if (data.id != ('j-'+data.formatDate)){
                data.id = ('j-'+data.formatDate);
            }
            updateAndRefreshSom(data)
        } else {
            if (!isCardEmpty(data.doc)) {
                data.id = 'j-' + data.formatDate;//generateUUID2();  这里使用日期字符串本身为ID
                updateAndRefreshSom(data);
            }
        }
    }

    const onEmptyData = async (data:any)=>{
        // if (data?.id) {
        //     szOldId.current = data.id;
        //     deleteCard(data.id).then(res => {
        //         refreshJournals();
        //         resetWeek(selectDate)
        //     });
        // }
    }

    const renderJournalInSideRight = ()=>{
        if (props.from == FROM_LIBRARY){

        }
    }

    /**
     * 拖动大小
     * @param nWidth
     */
    const onSliderEvent = (nWidth:number)=>{
        let nColumnCount = 5;
        if (nWidth > WIDTH_5){
            nColumnCount = 5;
            setGridColumns('repeat(5,auto)');
        }else if (nWidth > WIDTH_4){
            nColumnCount = 4;
            setGridColumns('repeat(4,auto)');
        }else if (nWidth > WIDTH_3){
            nColumnCount = 3;
            setGridColumns('repeat(3,auto)');
        }
        else{
            nColumnCount = 2;
            setGridColumns('repeat(2,auto)');
        }

        // if (props.subFromPage == 'DialogLink' || props.subFromPage == FROM_DIALOG || props.from == 'card'){
        //     nColumnCount = 3;
        //     setGridColumns('repeat(3,auto)');
        // }

        let fItemWidth = 200;
        const nMargin = (nColumnCount - 1)*12;
        fItemWidth = (nWidth - nMargin - 40)/nColumnCount;//40为左右2边的边距
        setCardItemSize({
            width:fItemWidth,
            height:0
        })
    }



    return (
        <>
            <div style={{display:'flex',height:'100%'}}>
            <div id={'div-journal-left-part'} style={{flexGrow:'1',minWidth:props.from == FROM_LIBRARY?'100%':'400px',background:isDarkMode()?(props.from == FROM_LIBRARY?'var(--journal-rightslider-libray-background-colorr)':'#363636'):'transparent'}}>
            {
                props.from == FROM_LIBRARY?
                    // 下面是右侧栏的-------**********************************/////
                    <div className={'flex-row-vertical-center default-font-size'}
                         style={{padding: '8px 20px', position: 'relative', fontSize: '13px', marginTop: '0px'}}>

                        {
                            <img className='img-32 hovered-gray-radius' style={{marginLeft:'-8px'}}
                                 src={getImagePathWithTheme('left_slider_2.svg')} onClick={()=>{
                                sideBarFoldRef.current?.onToggleBar();
                            }}/>
                        }

                        {/*<span*/}
                        {/*    className={'font-family-medium ml-4'}>{t(MAP_MONTH_FULL[(selectDate.getMonth() + 1) + ''])}</span>*/}

                        {/*//中间的*/}
                        <div className={'flex-row-vertical-center'} style={{
                            alignContent: 'center',
                            position: 'absolute',
                            left: '50%',
                            top: '50%',
                            transform: 'translate(-50%,-50%)'
                        }}>
                            <img className={'img-10 cursor-pointer'}
                                 src={getImagePathWithTheme('mini_left.svg')} onClick={() => {
                                //前一天
                                const newDate = moment(selectDate).add(-1, 'day');
                                onSelectedDataChange(newDate.toDate());
                            }}/>
                            <div style={{padding: '8px 0', marginTop: '2px', marginLeft: '12px', marginRight: '12px'}}
                                 className={'flex-row-vertical-center font-family-medium'}>
                                {/*<span className={'font-family-medium'} style={{*/}
                                {/*    marginTop: '0px'*/}
                                {/*}}>{t(MAP_WEEK[`${moment(selectDate).weekday() + 1}`])}</span>*/}
                                {/*<span className={'font-family-medium'} style={{*/}
                                {/*    marginLeft: '4px',*/}
                                {/*    marginTop: '0px'*/}
                                {/*}}>{selectDate.getDate()}</span>*/}
                                <span className={'font-family-medium'} style={{
                                    marginLeft: '4px',
                                    marginTop: '0px',
                                    cursor:'pointer',
                                    color:formatDate(selectDate) == formatDate(Date.now()) ? 'var(--item-no-select-color)' : '#3670F7',
                                }} onClick={()=>{
                                    mIsDateClicked.current = true;
                                    resetWeek(new Date());
                                }}>{t("Today")}</span>
                            </div>
                            <img className={'img-10 cursor-pointer'}
                                 src={getImagePathWithTheme('mini_right.svg')} onClick={() => {
                                //后一天
                                const newDate = moment(selectDate).add(1, 'day');
                                onSelectedDataChange(newDate.toDate());
                            }}/>
                        </div>

                        {/*//右边的*/}
                        <div className={'flex-row-vertical-center'} style={{marginLeft: 'auto'}}>
                            {/*<span className={'flex-center cursor-pointer'} style={{*/}
                            {/*    border: '1px solid var(--border-color)',*/}
                            {/*    minWidth: '60px',*/}
                            {/*    height: '24px',*/}
                            {/*    fontSize: '12px',*/}
                            {/*    visibility: formatDate(selectDate) == formatDate(Date.now()) ? 'hidden' : 'visible',*/}
                            {/*    borderRadius: '4px'*/}
                            {/*}} onClick={() => {*/}
                            {/*    mIsDateClicked.current = true;*/}
                            {/*    resetWeek(new Date());*/}
                            {/*}}>{t("Today")}</span>*/}

                            {
                                <Popover trigger={['click']} open={isOpenDatePicker}
                                         onOpenChange={(e) => setIsOpenDatePicker(e)}
                                         arrow={false} align={{offset: [-10, -10]}}
                                         content={
                                             <Calendar locale={enGB} style={{width: '264px'}}
                                                       value={dayjs(selectDate)}
                                                       fullscreen={false} fullCellRender={calendarCellRender}
                                                       headerRender={calendarHeaderRender} onChange={(date: any) => {
                                                 if (mIsChangeMonth) {
                                                     mSelectMonth = date.toDate().getMonth();
                                                     mIsChangeMonth = false;
                                                     return;
                                                 }
                                                 mIsDateClicked.current = true;
                                                 // setIsOpenDatePicker(false);
                                                 resetWeek(date.toDate())
                                             }}/>
                                         }>
                                    {/*<img style={{opacity: '1', width: '0px', height: '0px', minWidth: '0px', minHeight: '0px'}}*/}
                                    {/*     className={'img-16 cursor-pointer'} src={getImagePathWithTheme('home_journal')}*/}
                                    {/*     onClick={() => {*/}
                                    {/*        setIsOpenDatePicker(!isOpenDatePicker);*/}
                                    {/*     }}/>*/}
                                    <img className={'img-16 cursor-pointer ml-16 home_journal_1'}
                                         src={getImagePathWithTheme('home_journal_1.svg')}
                                         onClick={() => {
                                             setIsOpenDatePicker(!isOpenDatePicker);
                                         }}/>

                                </Popover>
                            }

                            <Dropdown trigger={['click']} menu={{items: MENU_MORE()}}>
                                <img className={'img-16 cursor-pointer ml-16 '} style={{marginRight: '2px',opacity:isDarkMode()?'0.55':'1'}}
                                     src={getImagePathWithTheme('note_card_h_more')}/>
                            </Dropdown>
                        </div>
                    </div> :
                    //下面是全屏日记页的....
                    <div className={'journal-header'} style={{borderBottom: '1px solid var(--card-bar-line-color)'}}>
                        <HomeNavigator margin={'0 0px 0 16px'}/>
                        {/*<img className={'img-16 cursor-pointer ml-4'} src={getImagePathWithTheme('home_journal')}*/}
                        {/*     onClick={() => {*/}
                        {/*         setIsLeftPartOpened(!isLeftPartOpened);*/}
                        {/*     }}/>*/}

                        {
                            selectView == 'daily' &&
                            <Tooltip overlayClassName='font-size-12' title={
                                <div>{t("Table of content")}<span
                                    className={'tooltip-shortcut-key'}>{getCtrlOrAlt("Ctrl + S")}</span></div>}
                                     arrow={false}>
                                <img className='img-32 hovered-gray-radius ml-10' onClick={() => {
                                    sideBarFoldRef.current?.onToggleBar();
                                }} src={getImagePathWithTheme('left_slider_2.svg')}/>
                            </Tooltip>
                        }

                        {
                            selectView == 'monthly' &&
                            <span style={{color:'var(--item-no-select-color)',marginLeft:'12px'}}>{t(MAP_MONTH_FULL[`${currentMonthlyDate.getMonth()+1}`]) + ' ' + currentMonthlyDate.getFullYear()}</span>
                        }


                        <div style={{flexGrow: '1'}}></div>

                        {/*左边*/}
                        {
                            /*
                            <>
                                <img className={'img-32 cursor-pointer'} src={getImagePathWithTheme('calendar_left')}
                                     onClick={() => {
                                         preWeek();
                                     }}/>

                                <div className={'ml-16'}
                                     style={{display: 'grid', gridTemplateColumns: 'repeat(7,auto)', flexGrow: '1'}}>
                                    {
                                        arrayCalendar.map(p => <div className={'flex-column-center cursor-pointer'}
                                                                    style={{
                                                                        background: p.isSelect ? 'var(--journal-date-background-color)' : 'transparent',
                                                                        borderRadius: '8px',
                                                                        padding: '0px 0',
                                                                        position: 'relative',
                                                                    }} onClick={() => {
                                            //单个日期点击
                                            var arrayNew = [...arrayCalendar];
                                            arrayNew.forEach(pp => {
                                                pp.isSelect = pp == p;
                                            });
                                            setArrayCalendar(arrayNew);
                                            setCurrentSelectDate(arrayNew);

                                            mSelectMonth = p.date.toDate().getMonth();
                                        }}>
                                            <div style={{
                                                padding: '8px 0',
                                                marginTop: '0px',
                                                marginLeft: '6px',
                                                marginRight: '6px'
                                            }}
                                                 className={'flex-row-vertical-center'}>
                                <span style={{
                                    color: p.isSelect ? 'var(--primary-color)' : 'var(--color-9A9A9A)',
                                    marginTop: '0px'
                                }}>{t(MAP_WEEK[`${p.week + 1}`])}</span>
                                                <span style={{
                                                    marginLeft: '4px',
                                                    color: p.isSelect ? 'var(--primary-color)' : 'var(--text-color)',
                                                    marginTop: '0px'
                                                }}>{p.day}</span>
                                            </div>

                                            <span style={{
                                                width: '4px',
                                                height: '4px',
                                                position: 'absolute',
                                                left: '50%',
                                                transform: 'translationX(-50%)',
                                                bottom: '4px',
                                                borderRadius: '2px',
                                                background: 'var(--primary-color)',
                                                display: 'block',
                                                visibility: p.hasJournal ? 'visible' : 'hidden'
                                            }}></span>
                                        </div>)
                                    }
                                </div>
                                <img className={'img-32 ml-16 cursor-pointer'}
                                     src={getImagePathWithTheme('calendar_right')}
                                     onClick={() => {
                                         nextWeek();
                                     }}/>
                            </>

                             */
                        }

                        <div style={{flexGrow: '1'}}></div>

                        {
                            /*
                            isOpenDatePicker &&
                            <Popover trigger={['click']} open={isOpenDatePicker}
                                     onOpenChange={(e) => setIsOpenDatePicker(e)}
                                     arrow={false} align={{offset: [-10, -10]}}
                                     content={
                                         <Calendar locale={enGB} style={{width: '300px'}}
                                                   defaultValue={dayjs(selectDate)}
                                                   fullscreen={false} fullCellRender={calendarCellRender}
                                                   headerRender={calendarHeaderRender} onChange={(date: any) => {
                                             if (mIsChangeMonth) {
                                                 mSelectMonth = date.toDate().getMonth();
                                                 mIsChangeMonth = false;
                                                 return;
                                             }
                                             setIsOpenDatePicker(false);
                                             resetWeek(date.toDate())
                                         }}/>
                                     }>
                                <img style={{
                                    opacity: '0',
                                    width: '0px',
                                    height: '0px',
                                    minWidth: '0px',
                                    minHeight: '0px'
                                }}
                                     className={'img-16 cursor-pointer'} src={getImagePathWithTheme('home_journal')}
                                     onClick={() => {

                                     }}/>
                            </Popover>

                             */
                        }

                        <img className={'img-10 cursor-pointer'} src={getImagePathWithTheme('mini_left.svg')} onClick={()=>{
                            if (selectView == 'daily') {
                                mIsDateClicked.current = true;
                                const newDate = selectDate;
                                newDate.setDate(newDate.getDate() - 1);
                                resetWeek(newDate);
                            }else {
                                //切换月视图
                                let newDate = currentMonthlyDate.setMonth(currentMonthlyDate.getMonth()-1);
                                //切换月视图
                                setCurrentMonthlyDate(new Date(newDate));
                                refreshJournalMonthly()
                            }
                        }}/>

                        {
                            selectView == 'daily'?
                            <span className={'flex-center cursor-pointer no-drag'} style={{
                                // border: '1px solid var(--color-dfdfdf)',
                                height: '26px',
                                fontSize: '12px',
                                margin:'0 12px',
                                cursor:'pointer',
                                // visibility:formatDate(selectDate) == formatDate(Date.now()) ? 'hidden' : 'visible',
                                color: formatDate(selectDate) == formatDate(Date.now()) ? 'var(--item-no-select-color)' : '#3670F7',
                                borderRadius: '8px'
                            }} onClick={() => {
                                mIsDateClicked.current = true;
                                resetWeek(new Date());
                            }}>{t("Today")}</span>:<div style={{width:'20px'}}></div>
                        }
                        <img className={'img-10 mr-16 cursor-pointer'} src={getImagePathWithTheme('mini_right.svg')} onClick={()=>{
                            if (selectView == 'daily') {
                                mIsDateClicked.current = true;
                                const newDate = selectDate;
                                newDate.setDate(newDate.getDate() + 1);
                                resetWeek(newDate);
                            }else {
                                let newDate = currentMonthlyDate.setMonth(currentMonthlyDate.getMonth()+1);
                                //切换月视图
                                setCurrentMonthlyDate(new Date(newDate));
                                refreshJournalMonthly()
                            }
                        }}/>

                        <div className={'flex-row-vertical-center journal-button-group mr-16 no-drag'}>
                            <span className={selectView == 'daily'?'journal-button-group-check':''} style={{background:selectView == 'daily'?'var(--button-group-background)':'transparent',color:selectView == 'daily'?'var(--text-color)':'var(--color-journal-daily-monthly-text-color)'}} onClick={()=>{
                                mIsDateClicked.current = true;
                                resetWeek(new Date());

                                setSelectView('daily');
                                localStorage.setItem(KEY_JOURNAL_SELECT_VIEW,'daily');
                            }}>{t("Daily")}</span>
                            <span className={selectView == 'monthly'?'journal-button-group-check':''} style={{background:selectView == 'monthly'?'var(--button-group-background)':'transparent',color:selectView == 'monthly'?'var(--text-color)':'var(--color-journal-daily-monthly-text-color)'}} onClick={()=>{
                                setSelectView('monthly');
                                localStorage.setItem(KEY_JOURNAL_SELECT_VIEW,'monthly');
                                refreshJournalMonthly();
                            }}>{t("Monthly")}</span>
                        </div>

                        <Popover trigger={['click']} open={isOpenDatePicker}
                                 onOpenChange={(e) => setIsOpenDatePicker(e)}
                                 arrow={false} align={{offset: [-10, -10]}}
                                 content={
                                     <ConfigProvider
                                         theme={{
                                             components: {
                                                 Calendar: {
                                                     /* 这里是你的组件 token */
                                                     miniContentHeight: 200
                                                 },
                                             },
                                         }}
                                     >
                                         <Calendar locale={enGB} style={{width: '254px'}} value={dayjs(selectDate)}
                                                   fullscreen={false} fullCellRender={calendarCellRender}
                                                   headerRender={calendarHeaderRender} onChange={(date: any) => {

                                         }} onSelect={async (date:any)=>{
                                             await setCurrentPopupJournal(date);
                                             if (mIsChangeMonth) {
                                                 mSelectMonth = date.toDate().getMonth();
                                                 mIsChangeMonth = false;
                                                 return;
                                             }
                                             mIsDateClicked.current = true;
                                             // setIsOpenDatePicker(false);
                                             resetWeek(date.toDate())
                                         }}/>
                                     </ConfigProvider>

                                 }>
                            <img className={'img-16 cursor-pointer ml-4 home_journal_2'} src={getImagePathWithTheme('home_journal_1.svg')}
                                 onClick={async () => {
                                     await setCurrentPopupJournal(selectDate);
                                     setIsOpenDatePicker(!isOpenDatePicker);
                                 }}/>
                        </Popover>


                        {
                            selectView == 'daily' &&
                                <Dropdown trigger={['click']} menu={{items: MENU_MORE()}}>
                                    <img className={'img-32 cursor-pointer ml-16'} style={{marginRight: '0px'}}
                                         src={getImagePathWithTheme('library_more_1.svg')}/>
                                </Dropdown>
                        }


                        {
                            rightSliderWidth == 0 &&
                            <img className='img-32 hovered-gray-radius'
                                 style={{marginLeft: APP_WEB_WWW ? '8px' : '8px'}}
                                 src={getImagePathWithTheme('home_slider_library.svg')} onClick={() => {
                                if (!cardJournal.id) {
                                    cardJournal.id = 'j-' + cardJournal.formatDate;
                                }
                                // window.openRightSlider(null, 'journal', {info: cardJournal});
                                window.openRightSlider(null, 'library');
                            }}/>
                        }
                    </div>
            }

                {
                    selectView == 'daily' &&
                    <div id={'JOURNAL_NOTE_V2_DOM'} className={'editor-container------'} style={{
                        marginTop: props.from == FROM_LIBRARY ? '0px' : '0px',
                        display: props.from == FROM_LIBRARY ? 'grid' : 'flex',
                        gridTemplateColumns: props.from == FROM_LIBRARY ? 'auto' : 'auto',
                        height: props.from == FROM_LIBRARY ? 'calc(100% - 50px)' : '100%',
                        background:isDarkMode()?'#191B1F':(props.from == FROM_LIBRARY?'var(--draw-libray-background-color)':'#FFFFFF')
                    }}>
                        {
                            props.from == FROM_LIBRARY ?
                                //下面是右侧栏的-------**********************************/////
                                <div className={'flex-row'} style={{padding:'0 18px',overflow:'hidden',height:'100%'}}>
                                    <div style={{
                                        position: 'relative', /*minWidth: `${headerTreeWidth}px`,*/
                                        overflow: 'hidden',
                                        width: '220px',
                                        flexShrink: '0',
                                        marginLeft: '-18px',
                                        borderTop:'1px solid var(--line-color)',
                                        display: sideBarStatus == 2 ? 'inherit' : 'none'
                                    }}>
                                        {
                                            editor &&
                                            <SideBarFold ref={sideBarFoldRef} editor={editor} from={FROM_RIGHT_SIDE}
                                                         data={cardJournal}
                                                         onCollapseCallback={(sidebarStatus: any) => {
                                                             if (sidebarStatus) {
                                                                 setHeaderTreeWidth(250)
                                                             } else {
                                                                 setHeaderTreeWidth(0)
                                                             }
                                                             setSideBarStatus(sidebarStatus);
                                                             editorRef.current?.onUpdateSidebarStatus(sidebarStatus);
                                                         }}/>
                                        }
                                    </div>
                                    <div style={{
                                        background: 'var(--draw-slider-card-background-color)',
                                        height: '100%',
                                        border: '1px solid var(--draw-slider-card-border-color)',
                                        borderRadius: '0px',
                                        // margin: '0 -8px',
                                        padding: '0 0px 0 8px',
                                        overflowY: 'auto',
                                        overflowX: 'hidden',
                                        width:'100%'
                                    }}>
                                        <Editor ref={editorRef} data={cardJournal} from={FROM_JOURNAL}
                                                subFrom={props.from} onSaveData={onSaveData}
                                                onEmptyData={onEmptyData} onInitComplete={(editor: any) => {
                                            setEditor(editor);
                                        }} onUpdate={(data: any) => {
                                            postMessage(EVENT_SYNC_JOURNAL_DATA_FROM_RIGHT_SLIDER, {data: data});
                                        }}/>
                                    </div>
                                    <div></div>
                                </div> :
                                //下面是全屏日记页的....
                                <>
                                    {
                                        //左边的部分..
                                        // isLeftPartOpened &&
                                        // <div style={{width: '300px', background: 'var(--home-left-background-color)',marginTop:'-56px',padding:'16px'}}>
                                        //     <Calendar locale={enGB} style={{width: '268px'}}
                                        //               value={dayjs(selectDate)}
                                        //               fullscreen={false} fullCellRender={calendarCellRender}
                                        //               headerRender={calendarHeaderRenderNew} onChange={(date: any) => {
                                        //         if (mIsChangeMonth) {
                                        //             mSelectMonth = date.toDate().getMonth();
                                        //             mIsChangeMonth = false;
                                        //             return;
                                        //         }
                                        //         mIsDateClicked.current = true;
                                        //         setIsOpenDatePicker(false);
                                        //         resetWeek(date.toDate())
                                        //     }}/>
                                        // </div>

                                        <div style={{
                                            position: 'relative', /*minWidth: `${headerTreeWidth}px`,*/
                                            overflow: 'hidden',
                                            width: rightSliderWidth > 0 ? '15%' : '15%',
                                            display: sideBarStatus == 2 ? 'inherit' : 'none',
                                            maxWidth: '240px',
                                            minWidth: '240px'
                                        }}>
                                            {
                                                editor &&
                                                // <HeadingTree ref={headingTreeRef} editor={editor} from={FROM_PAGE_CARD} onCollapseCallback={(isExpand: boolean) => {
                                                //     if (isExpand) {
                                                //         setHeaderTreeWidth(250)
                                                //     } else {
                                                //         setHeaderTreeWidth(0)
                                                //     }
                                                // }}/>
                                                <SideBarFold ref={sideBarFoldRef} editor={editor} from={FROM_PAGE_CARD}
                                                             data={cardJournal}
                                                             onCollapseCallback={(sidebarStatus: any) => {
                                                                 if (sidebarStatus) {
                                                                     setHeaderTreeWidth(250)
                                                                 } else {
                                                                     setHeaderTreeWidth(0)
                                                                 }
                                                                 setSideBarStatus(sidebarStatus);
                                                                 editorRef.current?.onUpdateSidebarStatus(sidebarStatus);
                                                             }}/>
                                            }
                                        </div>
                                    }

                                    {/*<div style={{*/}
                                    {/*    position: 'relative',*/}
                                    {/*    width: rightSliderWidth > 0 ? '15%' : '20%',*/}
                                    {/*    overflow: 'hidden'*/}
                                    {/*}}>*/}
                                    {/*    {*/}
                                    {/*        editor &&*/}
                                    {/*        <HeadingTree editor={editor} from={FROM_JOURNAL}*/}
                                    {/*                     onCollapseCallback={(isExpand: boolean) => {*/}
                                    {/*                         if (isExpand) {*/}
                                    {/*                             setHeaderTreeWidth(250)*/}
                                    {/*                         } else {*/}
                                    {/*                             setHeaderTreeWidth(0)*/}
                                    {/*                         }*/}
                                    {/*                     }}/>*/}
                                    {/*    }*/}
                                    {/*</div>*/}

                                    <div ref={divScrollContainer} className={'flex-col'} style={{
                                        flexGrow: '1',
                                        marginTop: '56px',
                                        // marginLeft: headerTreeWidth > 0 ? '100px' : '0px',
                                        height: isMac()?'calc(100vh - 120px)':'calc(100vh - 153px)',
                                        overflowY: 'auto',
                                        paddingRight: (rightSliderWidth > 0 && sideBarStatus == 2) ? '2%' : '15%',
                                        paddingLeft: (rightSliderWidth > 0 && sideBarStatus == 2) ? '2%' : '15%',
                                        width: rightSliderWidth > 0 ? '85%' : '80%'
                                    }}>
                                        {/*<span className={'font-family-semi-bold'}*/}
                                        {/*      style={{fontSize: '34px',marginTop:'6px'}}>{(formatDate(selectDate, 'MM dd,yyyy'))}</span>*/}

                                        <Editor ref={editorRef} data={cardJournal} from={FROM_JOURNAL}
                                                onSaveData={onSaveData}
                                                onEmptyData={onEmptyData} onInitComplete={(editor: any) => {
                                            setEditor(editor);
                                        }} onUpdate={(data: any) => {
                                            if (props.from != FROM_JOURNAL) {
                                                postMessage(EVENT_SYNC_CARD_DATA_FROM_PAGECARD, {data: data});
                                            }
                                        }}/>
                                    </div>
                                    {/*<div style={{}}></div>*/}
                                </>
                        }
                    </div>
                }

                {//月视图
                    selectView == 'monthly' &&
                    <div ref={divJournalMonthlyContainerRef} id={'divJournalMonthlyContainer'} style={{display: "grid",
                        gridTemplateColumns:gridColumns,
                        background:'var(--home-left-background-color)',
                        alignItems:'start',
                        // marginLeft: headerTreeWidth > 0 ? '100px' : '0px',
                        height: isMac()?'calc(100vh - 40px)':'calc(100vh - 70px)',
                        overflowY: 'auto',
                        // paddingRight:'15%',
                        // paddingLeft: '15%',
                        width: '100%',
                        alignContent:'start',//这个是上对齐-而非垂直平均居中拉伸
                        gap:props.from == FROM_ADD?'12px 32px':'12px',
                        flexDirection: "row",padding:'20px 20px'}} >
                        {
                            arrayJournalMonthly.map((item, i) =>
                                <CardItem key={i} data={item} itemWidth={cardItemSize.width}
                                          itemHeight={props.from == FROM_LIBRARY?(cardItemSize.width*0.77):cardItemSize.width*0.77}
                                          withPropertyHeight={cardItemSize.width*0.77 + 38}
                                          isTrash={false} from={props.from} subFrom={'journal'} isShowChecked={false}
                                          onCheckedCallback={(item:any)=>{

                                }} onActionCallback={async (szAction:string,item:any)=>{
                                    getCardById(item.id).then(res=>{
                                        onCardItemClick(szAction,res,null);
                                    })
                                }}></CardItem>)
                        }
                    </div>
                }


            </div>

                {/*right*/}
                {
                    props.from != FROM_LIBRARY &&
                    <div style={{width: `${rightSliderWidth}px`, flexShrink: '0'}}/>
                }


            </div>

            {
                tipsInfo &&
                <div className={'flex-center'} style={{
                    position: 'absolute',
                    zIndex: '9999999',
                    left: '50%',
                    transform: 'translateX(-50%)',
                    top: '80px',
                    height: '36px',
                    borderRadius: '8px',
                    padding: '0 26px',
                    minWidth: '180px',
                    boxShadow: 'var(--dialog-box-shadow)',
                    background: 'var(--dialog-background-color)'
                }}>
                    <span>{tipsInfo}</span>
                    <span style={{textDecoration: 'none', marginLeft: '22px'}} className={'link-color cursor-pointer'}
                          onClick={() => {
                              //打开这个project....
                              if (mProjectInfo) {
                                  window.navigateOrigin(getDrawPath(), {state: {noteData: mProjectInfo, searchKey: ''}})
                              }
                          }}>{t("View")}</span>
                </div>
            }

        </>
    )
})

export default PageJournal;




































